<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ oopt.transName }}</h1>
    <div class="workroom-pg">
      <div class="bgw-pdg-20 passport-pg create">
        <h3 class="title">
          {{ $t('География') }}
          <router-link tag="a"
           :to="{ name: 'View', params: { id: oopt.id } }"
           target="_blank"
           v-if="oopt.status === 1"
          >
            <img src="@/assets/img/collapse-icon.png" alt="icon">
          </router-link>
        </h3>
        <div class="tab-main">
          <v-form
            ref="form"
            @submit.prevent="updateOopt"
          >
            <v-tabs
              background-color="white"
              left
              v-model="langTab"
            >
              <v-tab>Русский</v-tab>
              <v-tab>Кыргызча</v-tab>
              <v-tab>English</v-tab>
              <v-tab-item v-for="tabItem in tabItems" :key="tabItem.violationTerritory">
                <div :class="{ 'form-label-copy': !tabItem.main }">
                  <!-- Нарушенность территории -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Нарушенность территории') }}:
                        <fieldInfo :info="$t('Нарушенность территории')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.violationTerritoryMain]" @copyText="copyText($event, tabItem.violationTerritory)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.violationTerritory]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Рельеф  -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Рельеф') }}:
                        <fieldInfo :info="$t('Рельеф')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.reliefMain]" @copyText="copyText($event, tabItem.relief)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.relief]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Климат -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Климат') }}:
                        <fieldInfo :info="$t('Климат')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.climateMain]" @copyText="copyText($event, tabItem.climate)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.climate]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Краткая характеристика почвенного покрова -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Краткая характеристика почвенного покрова') }}:
                        <fieldInfo :info="$t('Краткая характеристика почвенного покрова')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.briefDescrSoilCoverMain]" @copyText="copyText($event, tabItem.briefDescrSoilCover)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.briefDescrSoilCover]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Описание гидрологической сети -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Описание гидрологической сети') }}:
                        <fieldInfo :info="$t('Описание гидрологической сети')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.descHydrologicalNetMain]" @copyText="copyText($event, tabItem.descHydrologicalNet)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.descHydrologicalNet]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Сведения о лесных ресурсах -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Сведения о лесных ресурсах') }}:
                        <fieldInfo :info="$t('Сведения о лесных ресурсах')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.forestInfoMain]" @copyText="copyText($event, tabItem.forestInfo)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.forestInfo]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Характеристика основных экосистем ООПТ -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Характеристика основных экосистем ООПТ') }}:
                        <fieldInfo :info="$t('Характеристика основных экосистем ООПТ')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.majorEcoSystemCharacterMain]" @copyText="copyText($event, tabItem.majorEcoSystemCharacter)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.majorEcoSystemCharacter]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Природные лечебные и рекреационные ресурсы -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Природные лечебные и рекреационные ресурсы') }}:
                        <fieldInfo :info="$t('Природные лечебные и рекреационные ресурсы')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.naturalRecreationalResourcesMain]" @copyText="copyText($event, tabItem.naturalRecreationalResources)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.naturalRecreationalResources]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Факторы негативного воздействия -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Факторы негативного воздействия') }}:
                        <fieldInfo :info="$t('Факторы негативного воздействия')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.negImpactFactorMain]" @copyText="copyText($event, tabItem.negImpactFactor)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.negImpactFactor]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Угрозы негативного воздействия -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Угрозы негативного воздействия') }}:
                        <fieldInfo :info="$t('Угрозы негативного воздействия')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.negImpactThreatMain]" @copyText="copyText($event, tabItem.negImpactThreat)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.negImpactThreat]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                  <!-- Оценка современного состояния и вклада ООПТ в поддержании экологического баланса окружающих территорий -->
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Оценка современного состояния и вклада ООПТ в поддержании экологического баланса окружающих территорий') }}:
                        <fieldInfo :info="$t('Оценка современного состояния и вклада ООПТ в поддержании экологического баланса окружающих территорий')"/>
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <Copy v-if="!tabItem.main" :original="oopt[tabItem.assessmentCurrentStateMain]" @copyText="copyText($event, tabItem.assessmentCurrentState)"/>
                      <ckeditor
                        :editor="editor"
                        v-model="oopt[tabItem.assessmentCurrentState]"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-tab-item>
            </v-tabs>
            <div class="form-action">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                type="button"
                class="btn btn-default gray"
                @click="onCancel"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import OOPT from '@/model/oopt'
import fieldInfo from '@/components/app/fieldInfo'
import Copy from '@/components/oopt/Copy'
import { mapMutations } from 'vuex'

// ckeditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'

export default {
  components: {
    fieldInfo,
    Copy
  },
  data () {
    return {
      oopt: {},
      formData: {},
      langTab: null,
      breadcrumbs: [],
      tabItems: [
        {
          main: true,
          violationTerritory: 'violationTerritory',
          relief: 'relief',
          climate: 'climate',
          briefDescrSoilCover: 'briefDescrSoilCover',
          descHydrologicalNet: 'descHydrologicalNet',
          forestInfo: 'forestInfo',
          majorEcoSystemCharacter: 'majorEcoSystemCharacter',
          naturalRecreationalResources: 'naturalRecreationalResources',
          negImpactFactor: 'negImpactFactor',
          negImpactThreat: 'negImpactThreat',
          assessmentCurrentState: 'assessmentCurrentState'
        },
        {
          main: false,
          violationTerritoryMain: 'violationTerritory',
          reliefMain: 'relief',
          climateMain: 'climate',
          briefDescrSoilCoverMain: 'briefDescrSoilCover',
          descHydrologicalNetMain: 'descHydrologicalNet',
          forestInfoMain: 'forestInfo',
          majorEcoSystemCharacterMain: 'majorEcoSystemCharacter',
          naturalRecreationalResourcesMain: 'naturalRecreationalResources',
          negImpactFactorMain: 'negImpactFactor',
          negImpactThreatMain: 'negImpactThreat',
          assessmentCurrentStateMain: 'assessmentCurrentState',
          violationTerritory: 'violationTerritoryKg',
          relief: 'reliefKg',
          climate: 'climateKg',
          briefDescrSoilCover: 'briefDescrSoilCoverKg',
          descHydrologicalNet: 'descHydrologicalNetKg',
          forestInfo: 'forestInfoKg',
          majorEcoSystemCharacter: 'majorEcoSystemCharacterKg',
          naturalRecreationalResources: 'naturalRecreationalResourcesKg',
          negImpactFactor: 'negImpactFactorKg',
          negImpactThreat: 'negImpactThreatKg',
          assessmentCurrentState: 'assessmentCurrentStateKg'
        },
        {
          main: false,
          violationTerritoryMain: 'violationTerritory',
          reliefMain: 'relief',
          climateMain: 'climate',
          briefDescrSoilCoverMain: 'briefDescrSoilCover',
          descHydrologicalNetMain: 'descHydrologicalNet',
          forestInfoMain: 'forestInfo',
          majorEcoSystemCharacterMain: 'majorEcoSystemCharacter',
          naturalRecreationalResourcesMain: 'naturalRecreationalResources',
          negImpactFactorMain: 'negImpactFactor',
          negImpactThreatMain: 'negImpactThreat',
          assessmentCurrentStateMain: 'assessmentCurrentState',
          violationTerritory: 'violationTerritoryEn',
          relief: 'reliefEn',
          climate: 'climateEn',
          briefDescrSoilCover: 'briefDescrSoilCoverEn',
          descHydrologicalNet: 'descHydrologicalNetEn',
          forestInfo: 'forestInfoEn',
          majorEcoSystemCharacter: 'majorEcoSystemCharacterEn',
          naturalRecreationalResources: 'naturalRecreationalResourcesEn',
          negImpactFactor: 'negImpactFactorEn',
          negImpactThreat: 'negImpactThreatEn',
          assessmentCurrentState: 'assessmentCurrentStateEn'
        }
      ],
      // editor
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          HeadingPlugin,
          HorizontalLine,
          Alignment,
          Table,
          TableToolbar
        ],
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'alignment',
          '|',
          'horizontalLine',
          '|',
          'undo',
          'redo',
          '|',
          'insertTable'
        ],
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            }
          ]
        }
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // Валидация формы
    validateForm () {
      return true
    },
    // Данные для формы редактирования
    fetchData () {
      this.setLoading(true)

      OOPT.getOoptEditFormData(this.$route.params.id, 'geography')
        .then((response) => {
          this.oopt = { ...response.data.oopt }
          this.breadcrumbs = [
            { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
            { text: this.$i18n.t('Рабочий кабинет'), disabled: false, href: '/my-organization' },
            { text: this.oopt.transName, disabled: false, href: '/my-organization?id=' + this.oopt.id },
            { text: this.$i18n.t('Редактирование'), disabled: true }
          ]
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    // Обновление ООПТ
    updateOopt () {
      this.setLoading(true)
      this.formData = { ...this.oopt }
      delete this.formData.id
      delete this.formData.transName
      delete this.formData.status

      OOPT.updateOopt(this.oopt.id, 'geography', this.formData)
        .then((response) => {
          if (response.status === 200) {
            this.$noty.success(this.$i18n.t('Успешно обновлено'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            this.setLoading(false)
            this.$router.push({
              name: 'MyOrganization'
            })
          }
        })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.validateForm()
          this.$noty.error(msg, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          this.setLoading(false)
        })
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'MyOrganization'
      })
    },
    // Копирование текста для мультиязычности
    copyText (title, refName) {
      this.oopt[refName] = title
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
